/**
 * © 2022 Boston Consulting Group
 * Gamma D
 * Pardeep
 * Created: 2022-09-29
 */

// Add local dependencies.
import themeCodal from './themeCodal';

// Combine themes.
export default themeCodal;
